interface PhotoCaptionProps {
    location: string
    coordinates?: string // Optional: if provided, makes it a clickable link
    className?: string
}

function PhotoCaption({ location, coordinates, className = '' }: PhotoCaptionProps) {
    const content = `📍 ${location}`

    if (coordinates) {
        const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(coordinates)}`
        
        return (
            <div className={`mt-2 text-sm text-gray-500 ${className}`}>
                <a
                    href={mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center hover:text-lime-500 transition-colors"
                >
                    {content}
                </a>
            </div>
        )
    }

    return (
        <div className={`mt-2 text-sm text-gray-500 ${className}`}>
            {content}
        </div>
    )
}

export default PhotoCaption
